module.exports = __webpack_public_path__ + "img/NoVigCerso.2ac22b96.png";